import BpaERas from '../pages/BpaERas/Index'

import BpaC from '../pages/BpaERas/BpaC/Index'

import BpaI from '../pages/BpaERas/BpaI/Index'

import Ras from '../pages/BpaERas/Ras/Index'

export default [
  {
    path: '/bpa-e-ras',
    component: BpaERas,
  },
  {
    path: '/bpa-c',
    component: () => import('@/pages/BpaERas/BpaC/Template.vue'),
    children: [
      {
        path: '/bpa-c',
        component: BpaC,
      },
    ],
  },
  {
    path: '/bpa-i',
    component: () => import('@/pages/BpaERas/BpaI/Template.vue'),
    children: [
      {
        path: '/bpa-i',
        component: BpaI,
      },
    ],
  },
  {
    path: '/ras',
    component: () => import('@/pages/BpaERas/Ras/Template.vue'),
    children: [
      {
        path: '/ras',
        component: Ras,
      },
    ],
  },
  {
    path: '/exportar-bpa',
    component: () => import('@/pages/BpaERas/ExportarBpa/Index.vue'),
  },
]
